import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import ScrollReveal from '@/components/base/ScrollReveal';

export default function StoreInfo() {
  const { t } = useTranslation();

  return (
    <ScrollReveal as="section" className="py-20 md:py-28 px-4 md:px-6 relative overflow-hidden">
      <img
        src="https://storage.helloreaddy.io/project_files/fbab44cd-04c6-492b-a442-ed8f359ae362/c472d3a9-79c1-4f18-8d04-73df085acd2f_compressed_8.webp"
        alt=""
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-white/10" />
      <div className="relative z-10 max-w-4xl mx-auto text-center">
        <p className="font-heading text-xs md:text-sm tracking-[0.3em] text-accent-600 mb-4 reveal-child">
          {t('storeinfo_label')}
        </p>
        <h2 className="font-heading text-2xl md:text-3xl tracking-wider text-foreground-900 mb-10 reveal-child reveal-delay-1">
          {t('storeinfo_title')}
        </h2>

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 mb-12 reveal-child reveal-delay-2">
          <div className="p-6">
            <div className="w-10 h-10 flex items-center justify-center mx-auto mb-4">
              <i className="ri-time-line text-2xl text-foreground-500" />
            </div>
            <h3 className="text-sm tracking-widest text-foreground-700 font-label mb-3">
              {t('storeinfo_hours')}
            </h3>
            <div className="text-xs text-foreground-600 leading-relaxed space-y-1">
              <p>{t('storeinfo_hours_lunch')}</p>
              <p>{t('storeinfo_hours_lunch_lo')}</p>
              <p>{t('storeinfo_hours_dinner')}</p>
              <p>{t('storeinfo_hours_dinner_lo')}</p>
              <p className="mt-2">{t('storeinfo_closed')}</p>
            </div>
          </div>

          <div className="p-6">
            <div className="w-10 h-10 flex items-center justify-center mx-auto mb-4">
              <i className="ri-map-pin-line text-2xl text-foreground-500" />
            </div>
            <h3 className="text-sm tracking-widest text-foreground-700 font-label mb-3">
              {t('storeinfo_access')}
            </h3>
            <div className="text-xs text-foreground-600 leading-relaxed space-y-1 whitespace-pre-line">
              <p>{t('storeinfo_access_val')}</p>
            </div>
          </div>

          <div className="p-6">
            <div className="w-10 h-10 flex items-center justify-center mx-auto mb-4">
              <i className="ri-calendar-check-line text-2xl text-foreground-500" />
            </div>
            <h3 className="text-sm tracking-widest text-foreground-700 font-label mb-3">
              {t('storeinfo_contact')}
            </h3>
            <div className="text-xs text-foreground-600 leading-relaxed space-y-1">
              <Link to="/reservation" className="text-base tracking-wider text-foreground-600 hover:text-accent-600 transition-colors">
                {t('storeinfo_reservation')}
              </Link>
            </div>
          </div>
        </div>

        {/* CTA */}
        <Link
          to="/reservation"
          className="inline-flex items-center gap-3 px-10 py-4 bg-primary-500 text-background-50 text-sm tracking-widest rounded-md hover:bg-primary-600 transition-all duration-500 font-label whitespace-nowrap reveal-child reveal-delay-3"
        >
          <i className="ri-calendar-check-line text-lg" />
          {t('storeinfo_reservation')}
        </Link>

        {/* SNS */}
        <div className="mt-8 flex items-center justify-center gap-6 reveal-child reveal-delay-4">
          <a
            href="https://x.com/takazusi_ikeb96"
            target="_blank"
            rel="noopener noreferrer"
            className="w-11 h-11 flex items-center justify-center rounded-full border border-foreground-300 text-foreground-600 hover:bg-foreground-900 hover:text-background-50 transition-all duration-500"
            aria-label="X（旧Twitter）"
          >
            <i className="ri-twitter-x-fill text-lg" />
          </a>
        </div>
      </div>
    </ScrollReveal>
  );
}